import React from 'react'
import { jt, t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'

import styles from './DeleteInterviewTemplateCategoryModal.module.scss'

export const DeleteInterviewTemplateCategoryModal = ({
  category,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const message = <strong key={category}>{category}</strong>

  return (
    <Modal
      className={styles.modal}
      cancelLabel={t`Cancel`}
      confirmLabel={t`Remove category`}
      title={t`Remove category`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <p
          className={styles.text}
        >{jt`You are removing ${message} category.`}</p>
        <p
          className={styles.text}
        >{t`You will not be able to revert this action.`}</p>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
